document.addEventListener('DOMContentLoaded', function() {
(function() {
  'use strict';

  const SID = window.cmPDPSectionId;
  const data = window['cmPDP_' + SID];

  /* ── Utilidades ── */
  function $(id) { return document.getElementById(id); }
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
  function formatMoney(cents) {
    if (!data) return cents;
    const amount = (cents / 100).toFixed(2);
    return data.moneyFormat
      .replace('{' + '{amount}}', amount)
      .replace('{' + '{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{' + '{amount_no_decimals}}', Math.round(cents / 100));
  }

  /* ── Galería — thumbnails ── */
  const mainImg = $('cm-main-img-' + SID);
  const imgWrap = mainImg ? mainImg.closest('.cm-pdp__main-img-wrap') : null;

  function numOrFallback(value, fallback) {
    const n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }


  function applyThumbAdjust(btn) {
    if (!imgWrap || !btn) return;
    /* Los ajustes vienen del HTML (data-*), sobreviven re-renders del Editor.
       El zoom y la posición se aplican en los dos modos: en 'Contener' también
       son válidos para agrandar la foto dentro del marco. */
    imgWrap.style.setProperty('--gal-fit',   btn.dataset.imgFit || data.galFit);
    imgWrap.style.setProperty('--gal-zoom',  numOrFallback(btn.dataset.imgZoom, data.galZoomRaw) / 100);
    imgWrap.style.setProperty('--gal-pos-x', numOrFallback(btn.dataset.imgPosX, data.galPosX) + '%');
    imgWrap.style.setProperty('--gal-pos-y', numOrFallback(btn.dataset.imgPosY, data.galPosY) + '%');
  }

  if (mainImg) {
    document.querySelectorAll('.cm-pdp__thumb-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        applyThumbAdjust(btn);
        mainImg.classList.add('is-loading');
        const newSrc = btn.dataset.imageSrc;
        const tempImg = new Image();
        tempImg.onload = () => {
          mainImg.src = newSrc;
          mainImg.alt = btn.dataset.imageAlt || '';
          mainImg.classList.remove('is-loading');
        };
        tempImg.src = newSrc;
        document.querySelectorAll('.cm-pdp__thumb-btn').forEach(t => t.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });
  }

  /* Shopify Editor: al seleccionar un bloque image_adjust, saltar a su imagen automáticamente */
  document.addEventListener('shopify:block:select', function(evt) {
    var blockId = evt.detail && evt.detail.blockId;
    if (!blockId) return;
    var thumb = document.querySelector('.cm-pdp__thumb-btn[data-block-id="' + blockId + '"]');
    if (thumb) thumb.click();
  });

  /* ── Selector de curación (dropdown) ── */
  const curingSelect = document.querySelector('#cm-curing-' + SID + ' [data-curing-select]');
  const curingHint   = $('cm-curing-hint-' + SID);
  if (curingSelect) {
    curingSelect.addEventListener('change', function() {
      const opt = this.options[this.selectedIndex];
      if (curingHint) curingHint.textContent = opt.dataset.desc || '';
    });
  }

  /* ── Opciones a la vista (botones en vez de desplegables) ──
     El <select> sigue en el DOM, oculto: el resto del script lee su valor y escucha 'change'. */
  function prettyOptionLabel(text) {
    const m = String(text).match(/^(\d+(?:\.\d+)?)\s*kg\s*-\s*(\d+(?:\.\d+)?)\s*kg$/i);
    return m ? parseFloat(m[1]) + '–' + parseFloat(m[2]) + ' kg' : text;
  }

  function setCheckedOption(group, checkedBtn) {
    const btns = group.querySelectorAll('.cm-pdp__opt');
    btns.forEach(function(btn) {
      const on = btn === checkedBtn;
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.tabIndex = (on || (!checkedBtn && btn === btns[0])) ? 0 : -1;
    });
  }

  function syncOptionButtons(select) {
    const group = select._cmOpts;
    if (!group) return;
    let checked = null;
    group.querySelectorAll('.cm-pdp__opt').forEach(function(btn) {
      if (btn.dataset.value === select.value) checked = btn;
    });
    setCheckedOption(group, checked);
  }

  /* El pack ("1 ud.", "10 ud."…) fija la cantidad; si la cantidad se cambia con +/− a un valor sin botón, ninguno queda marcado. */
  function syncPackButtons() {
    const select = document.querySelector('[data-pack-select]');
    const group = select && select._cmOpts;
    if (!group) return;
    let checked = null;
    group.querySelectorAll('.cm-pdp__opt').forEach(function(btn) {
      const n = btn.dataset.value.match(/^(\d+)/);
      if (n && parseInt(n[1], 10) === getQty()) checked = btn;
    });
    setCheckedOption(group, checked);
  }

  function enhanceSelect(select) {
    const wrap = select.closest('.cm-pdp__select-wrap');
    if (!wrap || wrap.classList.contains('has-opts')) return;
    const group = document.createElement('div');
    const cards = (wrap.dataset.optName || '').toLowerCase() === 'formato';
    group.className = 'cm-pdp__opts' + (cards ? ' cm-pdp__opts--cards' : '');
    group.setAttribute('role', 'radiogroup');
    const label = select.id ? document.querySelector('label[for="' + select.id + '"]') : null;
    if (label) {
      if (!label.id) label.id = select.id + '-label';
      group.setAttribute('aria-labelledby', label.id);
    }
    Array.prototype.forEach.call(select.options, function(opt) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cm-pdp__opt';
      btn.setAttribute('role', 'radio');
      btn.dataset.value = opt.value;
      const nameEl = document.createElement('span');
      nameEl.className = 'cm-pdp__opt-name';
      nameEl.textContent = prettyOptionLabel(opt.textContent);
      btn.appendChild(nameEl);
      if (cards && opt.dataset.desc) {
        const descEl = document.createElement('span');
        descEl.className = 'cm-pdp__opt-desc';
        descEl.textContent = opt.dataset.desc;
        btn.appendChild(descEl);
      }
      btn.addEventListener('click', function() {
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        if (select.hasAttribute('data-pack-select')) syncPackButtons(); else syncOptionButtons(select);
      });
      group.appendChild(btn);
    });
    group.addEventListener('keydown', function(e) {
      const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (!keys[e.key]) return;
      const btns = Array.prototype.slice.call(group.querySelectorAll('.cm-pdp__opt'));
      const i = btns.indexOf(document.activeElement);
      if (i === -1) return;
      e.preventDefault();
      const next = btns[(i + keys[e.key] + btns.length) % btns.length];
      next.focus();
      next.click();
    });
    wrap.insertBefore(group, select);
    wrap.classList.add('has-opts');
    select._cmOpts = group;
    syncOptionButtons(select);
  }

  document.querySelectorAll('#cm-pdp-' + SID + ' select.cm-pdp__select').forEach(enhanceSelect);

  /* ── Selector de cantidad ── */
  const qtyInput = $('cm-qty-' + SID);
  const qtyMinus = $('cm-qty-minus-' + SID);
  const qtyPlus  = $('cm-qty-plus-' + SID);

  function getQty() { return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1; }

  /* Descuentos por cantidad: deben coincidir con los descuentos automáticos de Shopify
     (Admin > Descuentos). Jamón cortado a mano/a máquina: -10% desde 10 uds.
     Embutido loncheado: -5% desde 5 uds. */
  const VOLUME_RULES = {
    jamon:    { minQty: 10, pct: 10 },
    embutido: { minQty: 5,  pct: 5 }
  };

  /* Criterio por etiquetas exactas (no por substring): embutido loncheado = "embutido" + "loncheado";
     jamón loncheado = "cortado a mano" o "cortado a máquina". Si hay etiquetas de ambos tipos, manda embutido. */
  function volumeRuleFor(tags) {
    if (tags.includes('embutido') && tags.includes('loncheado')) return VOLUME_RULES.embutido;
    if (tags.includes('cortado a mano') || tags.includes('cortado a máquina')) return VOLUME_RULES.jamon;
    return null;
  }

  /* Packs con vino/vermut (IVA 21 %): llevan la etiqueta "con-alcohol" y no deben salir en las sugerencias.
     /recommendations/products.json y /collections/<handle>/products.json devuelven las etiquetas (tags). */
  function sinAlcohol(list) {
    return (list || []).filter(function (p) {
      return !(p.tags || []).some(function (t) { return String(t).trim().toLowerCase() === 'con-alcohol'; });
    });
  }

  function volumeDiscountPct(qty, rule) {
    return qty >= rule.minQty ? rule.pct : 0;
  }

  /* ── Barra de envío gratis de la ficha (snippets/free-shipping-bar.liquid, pdp: true) ──
     Mismo criterio que el carrito: lo que falta según lo que ya hay en él, sin sumar el producto de la ficha. */
  const pdpShipbar = document.querySelector('[data-cm-shipbar-pdp]');
  function updatePdpShipbar() {
    if (!pdpShipbar) return;
    const threshold = parseInt(pdpShipbar.getAttribute('data-threshold'), 10);
    const cartTotal = parseInt(pdpShipbar.getAttribute('data-cart-total'), 10) || 0;
    const remaining = Math.max(threshold - cartTotal, 0);
    const percent = Math.min(Math.round(cartTotal * 100 / threshold), 100);
    const text = pdpShipbar.querySelector('[data-cm-shipbar-text]');
    const fill = pdpShipbar.querySelector('[data-cm-shipbar-fill]');
    const track = pdpShipbar.querySelector('[role="progressbar"]');
    pdpShipbar.classList.toggle('is-complete', remaining === 0);
    if (text) {
      text.innerHTML = remaining === 0
        ? cmT('shipbar_free_html', '¡Tienes <strong>envío gratis</strong>!')
        : cmT('shipbar_remaining_html', 'Te faltan <strong>{amount}</strong> para el envío gratis', { amount: formatMoney(remaining) });
    }
    if (fill) fill.style.width = percent + '%';
    if (track) track.setAttribute('aria-valuenow', percent);
  }

  /* El carrito lateral avisa con 'cm:cart-updated' al quitar, cambiar cantidades o añadir */
  document.addEventListener('cm:cart-updated', function (e) {
    if (!pdpShipbar || !e.detail || !e.detail.cart) return;
    pdpShipbar.setAttribute('data-cart-total', e.detail.cart.total_price);
    updatePdpShipbar();
  });

  function updateVolumDiscount() {
    const tags = (data && data.tags) ? data.tags.map(t => String(t).trim().toLowerCase()) : [];
    const rule = volumeRuleFor(tags);
    if (!rule) return;

    const qty = getQty();
    const variant = findVariant();
    if (!variant) return;

    const basePrice = variant.price;
    const discount = volumeDiscountPct(qty, rule);

    const volDiscEl = $('cm-volume-discount-' + SID);
    const origEl = $('cm-volume-discount-original-' + SID);
    const priceEl = $('cm-volume-discount-price-' + SID);
    const badgeEl = $('cm-volume-discount-badge-' + SID);
    const priceWrapEl = $('cm-price-wrap-' + SID);

    if (discount > 0) {
      const totalPrice = qty * basePrice;
      /* Replica el redondeo por unidad de Shopify: TRUNCA al céntimo el descuento de CADA unidad y luego
         multiplica por la cantidad; así el total de la ficha coincide con el del carrito
         (p. ej. 5 uds de 3,99 € a -5 %: 5 x (3,99 - 0,19) = 19,00 €; 10 uds de 18,99 € a -10 %: 10 x (18,99 - 1,89) = 171,00 €).
         basePrice está en céntimos: basePrice * discount / 100 es el descuento unitario en céntimos (se trunca).
         Regla observada (27/10/2026) con 10 carritos de la tarifa; Shopify no la documenta. El 25/10 se había
         creído «mitades hacia abajo», que solo coincidía con los precios antiguos. Si cambian los precios o los
         porcentajes, volver a probar con tools/probar_tienda.js tarifa. */
      const unitDiscount = Math.floor(basePrice * discount / 100);
      const discountedTotal = qty * (basePrice - unitDiscount);
      const origPrice = formatMoney(totalPrice);
      const discPrice = formatMoney(discountedTotal);

      if (origEl) origEl.textContent = origPrice;
      if (priceEl) priceEl.textContent = discPrice;
      if (badgeEl) badgeEl.textContent = '-' + discount + '%';
      if (volDiscEl) volDiscEl.style.display = '';
      if (priceWrapEl) priceWrapEl.style.display = 'none';
    } else {
      if (volDiscEl) volDiscEl.style.display = 'none';
      if (priceWrapEl) priceWrapEl.style.display = '';
    }
  }

  function setQty(v) {
    v = Math.max(1, v);
    if (qtyInput) qtyInput.value = v;
    const stickyVal = $('cm-sticky-qty-val-' + SID);
    if (stickyVal) stickyVal.value = v;
    updateVolumDiscount();
    syncPackButtons();
  }

  if (qtyInput) {
    qtyMinus?.addEventListener('click', () => setQty(getQty() - 1));
    qtyPlus?.addEventListener('click',  () => setQty(getQty() + 1));
    qtyInput.addEventListener('change', () => setQty(parseInt(qtyInput.value, 10)));
  }

  /* ── Pack selector (cortado a mano) ── */
  const packSelect = document.querySelector('[data-pack-select]');
  if (packSelect) {
    packSelect.addEventListener('change', () => {
      const packVal = packSelect.value.trim();
      const qtyMatch = packVal.match(/^(\d+)/);
      if (qtyMatch) {
        const qty = parseInt(qtyMatch[1], 10);
        setQty(qty);
      }
    });
  }

  /* ── Qty sticky sincronizada ── */
  const stickyQtyMinus = $('cm-sticky-qty-minus-' + SID);
  const stickyQtyPlus  = $('cm-sticky-qty-plus-' + SID);
  const stickyQtyInput = $('cm-sticky-qty-val-' + SID);
  stickyQtyMinus?.addEventListener('click', () => setQty(getQty() - 1));
  stickyQtyPlus?.addEventListener('click',  () => setQty(getQty() + 1));
  stickyQtyInput?.addEventListener('change', () => setQty(parseInt(stickyQtyInput.value, 10)));

  /* ── Selector de variantes ── */
  const selectedOptions = {};
  document.querySelectorAll('.cm-pdp__select[data-section="' + SID + '"]').forEach(sel => {
    selectedOptions[sel.dataset.optionIndex] = sel.value;
    sel.addEventListener('change', () => {
      selectedOptions[sel.dataset.optionIndex] = sel.value;
      updateVariant();
    });
  });

  function findVariant() {
    if (!data) return null;
    const hasSelectors = Object.keys(selectedOptions).length > 0;
    if (!hasSelectors) {
      return data.variants[0];
    }
    return data.variants.find(v => {
      const m1 = !v.option1 || v.option1 === selectedOptions[1];
      const m2 = !v.option2 || v.option2 === selectedOptions[2];
      const m3 = !v.option3 || v.option3 === selectedOptions[3];
      return m1 && m2 && m3;
    });
  }

  function updateWeightPackSelector() {
    const sectionEl = document.querySelector('#cm-pdp-' + SID);
    if (!sectionEl || !data) {
      return;
    }

    // Detectar formato desde product.tags
    let selectorType = 'entero';
    let formatLabel = 'Pieza Entera';
    const tags = data.tags || [];
    const tagsLower = tags.map(t => String(t).trim().toLowerCase());

    if (tagsLower.some(t => t.includes('loncheado'))) {
      selectorType = 'lonchado';
      formatLabel = 'Loncheado';
    } else if (tagsLower.some(t => t.includes('cortado'))) {
      selectorType = 'cortado';
      formatLabel = 'Loncheado';
    } else if (tagsLower.some(t => t.includes('deshuesado'))) {
      selectorType = 'deshuesado';
      formatLabel = 'Deshuesado';
    } else if (tagsLower.some(t => t.includes('pieza'))) {
      selectorType = 'entero';
      formatLabel = 'Pieza Entera';
    }

    const selectors = sectionEl.querySelectorAll('[data-selector-type]');
    selectors.forEach(selector => {
      if (selector.getAttribute('data-selector-type').split(' ').indexOf(selectorType) !== -1) {
        selector.style.display = '';
      } else {
        selector.style.display = 'none';
      }
    });

    // Actualizar el elemento de formato en la banda de confianza
    const formatDescEl = document.querySelector('#cm-trust-formato-desc');
    const formatCell = document.querySelector('#cm-trust-formato');
    if (formatDescEl) {
      formatDescEl.textContent = formatLabel;
    }
    if (formatCell) {
      formatCell.setAttribute('data-format-type', selectorType);
    }

    // Mostrar/ocultar selector de curación según el tipo de producto
    const curingSelector = sectionEl.querySelector('.cm-curing-selector');
    if (curingSelector) {
      if (selectorType === 'entero') {
        curingSelector.style.display = '';
      } else {
        curingSelector.style.display = 'none';
      }
    }
  }

  /* Formato (Pieza entera / Deshuesado / Corte…): el €/kg solo tiene sentido con la pieza entera,
     y cada formato muestra su suplemento sobre la pieza del peso elegido. */
  function formatoOptionIndex() {
    return data && data.options ? data.options.indexOf('Formato') : -1;
  }

  function updatePriceKg(variant) {
    const el = document.querySelector('#cm-pdp-' + SID + ' .cm-pdp__price-kg');
    const idx = formatoOptionIndex();
    if (idx < 0 || !variant) return;
    const formato = variant['option' + (idx + 1)];
    if (el) el.style.display = formato === 'Pieza entera' ? '' : 'none';
    /* La banda de confianza muestra el formato elegido */
    const bandDesc = document.querySelector('#cm-trust-formato-desc');
    if (bandDesc && formato) bandDesc.textContent = formato;
  }

  function refreshFormatoExtras() {
    const idx = formatoOptionIndex();
    if (idx < 0 || !data) return;
    const select = document.querySelector('#cm-pdp-' + SID + ' select[data-option-index="' + (idx + 1) + '"]');
    const group = select && select._cmOpts;
    if (!group) return;
    function priceFor(formato) {
      const v = data.variants.find(function(x) {
        return [1, 2, 3].every(function(n) {
          const want = n === idx + 1 ? formato : selectedOptions[n];
          return !x['option' + n] || x['option' + n] === want;
        });
      });
      return v ? v.price : null;
    }
    const base = priceFor('Pieza entera');
    group.querySelectorAll('.cm-pdp__opt').forEach(function(btn) {
      const old = btn.querySelector('.cm-pdp__opt-extra');
      if (old) old.remove();
      const p = priceFor(btn.dataset.value);
      if (base === null || p === null || p === base) return;
      const extra = document.createElement('span');
      extra.className = 'cm-pdp__opt-extra';
      extra.textContent = (p > base ? '+' : '−') + formatMoney(Math.abs(p - base)).replace(/[,.]00(?!\d)/, '');
      btn.appendChild(extra);
    });
  }

  /* Inicializar selector al cargar */
  updateWeightPackSelector();
  updateVolumDiscount();
  updatePriceKg(findVariant());
  refreshFormatoExtras();

  function updateVariant() {
    const variant = findVariant();
    if (!variant) return;

    /* ID oculto */
    const idInput = $('cm-variant-id-' + SID);
    if (idInput) idInput.value = variant.id;

    updatePriceKg(variant);
    refreshFormatoExtras();

    /* Precio */
    const priceEl  = $('cm-price-' + SID);
    const cmpEl    = $('cm-compare-price-' + SID);
    const badgeEl  = $('cm-discount-badge-' + SID);
    const stickyP  = $('cm-sticky-price-' + SID);

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
      priceEl.classList.toggle('cm-pdp__price--sale', variant.compare_at_price > variant.price);
    }
    if (cmpEl) {
      if (variant.compare_at_price > variant.price) {
        cmpEl.textContent = formatMoney(variant.compare_at_price);
        cmpEl.style.display = '';
      } else {
        cmpEl.style.display = 'none';
      }
    }
    if (badgeEl) {
      if (variant.compare_at_price > variant.price) {
        const pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        badgeEl.textContent = '-' + pct + '%';
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }
    }
    if (stickyP) stickyP.textContent = formatMoney(variant.price);

    /* Botón añadir */
    const addBtn  = $('cm-add-' + SID);
    const addText = $('cm-add-text-' + SID);
    const stickyBtn = $('cm-sticky-btn-' + SID);
    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? cmT('add_to_cart', 'Añadir a la cesta') : cmT('sold_out', 'Agotado');
    }
    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available ? cmT('add_to_cart', 'Añadir a la cesta') : cmT('sold_out', 'Agotado');
    }

    /* Imagen de variante */
    if (variant.featured_image && mainImg) {
      mainImg.classList.add('is-loading');
      const tempImg = new Image();
      tempImg.onload = () => {
        mainImg.src = variant.featured_image.src;
        mainImg.classList.remove('is-loading');
      };
      tempImg.src = variant.featured_image.src;
    }

    /* Actualizar selectores de peso/pack según tipo de variante */
    updateWeightPackSelector();

    /* Actualizar descuento por volumen */
    updateVolumDiscount();
  }

  /* ── AJAX añadir al carrito ── */
  function loadCombinaProducts() {
    var track = document.getElementById('cm-combina-track');
    if (!track || track.dataset.loaded) return;
    track.dataset.loaded = 'true';

    var productId = data.productId;

    function renderProducts(products) {
      if (!products || products.length === 0) {
        track.innerHTML = '<p style="padding:8px 0;color:var(--text-secondary);font-family:var(--cm-font-sans);font-size:14px;">Sin productos relacionados disponibles.</p>';
        return;
      }
      track.innerHTML = '';
      products.forEach(function(p) {
        var cents = p.variants && p.variants[0] ? p.variants[0].price : 0;
        var price = (cents / 100).toFixed(2).replace('.', ',') + ' €';
        var img = p.featured_image || '';
        var card = document.createElement('a');
        card.href = p.url;
        card.className = 'cm-combina__card';
        card.innerHTML =
          '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" class="cm-combina__card-img" loading="lazy">' +
          '<p class="cm-combina__card-title">' + escapeHtml(p.title) + '</p>' +
          '<p class="cm-combina__card-price">' + price + '</p>';
        track.appendChild(card);
      });

      var wrap = document.getElementById('cm-combina-wrap');
      var prevBtn = document.getElementById('cm-combina-prev');
      var nextBtn = document.getElementById('cm-combina-next');
      if (wrap && prevBtn && nextBtn) {
        function scrollByCard(dir) {
          var card = track.querySelector('.cm-combina__card');
          if (card) wrap.scrollLeft += dir * (card.offsetWidth + 16);
        }
        prevBtn.addEventListener('click', function() { scrollByCard(-1); });
        nextBtn.addEventListener('click', function() { scrollByCard(1); });
        wrap.addEventListener('scroll', function() {
          prevBtn.disabled = wrap.scrollLeft <= 0;
          nextBtn.disabled = wrap.scrollLeft >= wrap.scrollWidth - wrap.offsetWidth - 1;
        });
        prevBtn.disabled = true;
      }
    }

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=complementary')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var lista = sinAlcohol(d.products);
        if (lista.length > 0) {
          renderProducts(lista);
        } else {
          return fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
            .then(function(r) { return r.json(); })
            .then(function(d2) { renderProducts(sinAlcohol(d2.products)); });
        }
      })
      .catch(function() {
        track.innerHTML = '<p style="padding:8px 0;color:var(--text-secondary);font-family:var(--cm-font-sans);font-size:14px;">No se pudieron cargar los productos.</p>';
      });
  }

  function revealCombina() {
    const el = document.getElementById('cm-combina-section');
    if (!el) return;
    el.style.display = 'block';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.classList.add('is-animating');
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300);
      });
    });
  }

  /* ── ATC en tarjetas de combina ── */
  var CHECK_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cm-combina__card-plus[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="3" fill="currentColor"/></svg>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(async function() {
      btn.innerHTML = CHECK_PLUS;
      btn.classList.add('is-added');
      updateCartCount();
      if (typeof window.fetchAndRenderCart === 'function') {
        await window.fetchAndRenderCart();
      }
      if (typeof window.openCart === 'function') {
        window.openCart(true);
      }
      setTimeout(function() {
        btn.innerHTML = original;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 2000);
    })
    .catch(function() {
      btn.innerHTML = original;
      btn.disabled = false;
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        /* Sin ".cart-count": es la clase del encabezado del cajón ("TU CESTA (n)") y pisaba todo su texto.
           El número del cajón y la burbuja de la cabecera los actualiza cart-drawer.js (fetchAndRenderCart). */
        document.querySelectorAll('[data-cart-count], .header__cart-count, .js-cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.setAttribute('aria-label', cmT('cart_items_aria', '{n} artículos en la cesta', { n: cart.item_count }));
        });
        if (pdpShipbar) {
          pdpShipbar.setAttribute('data-cart-total', cart.total_price);
          updatePdpShipbar();
        }
      })
      .catch(() => {});
  }

  function setAddBtnState(state) {
    const addBtn    = $('cm-add-' + SID);
    const addText   = $('cm-add-text-' + SID);
    const stickyBtn = $('cm-sticky-btn-' + SID);
    const labels = { idle: cmT('add_to_cart', 'Añadir a la cesta'), loading: cmT('adding', 'Añadiendo…'), done: cmT('added', '✓ Añadido') };
    if (addBtn)    addBtn.disabled = (state !== 'idle');
    if (addText)   addText.textContent = labels[state] || labels.idle;
    if (stickyBtn) { stickyBtn.disabled = (state !== 'idle'); stickyBtn.textContent = labels[state] || labels.idle; }
  }

  const mainForm = $('cm-form-' + SID);
  let isSubmitting = false;

  async function addToCartAjax() {
    if (isSubmitting) return;
    isSubmitting = true;

    const variantId = $('cm-variant-id-' + SID)?.value;
    if (!variantId) { isSubmitting = false; return; }

    setAddBtnState('loading');

    try {
      const sectionEl = document.querySelector('#cm-pdp-' + SID);
      const curingSelectEl = sectionEl ? sectionEl.querySelector('[data-curing-select]') : null;
      const curingVal = curingSelectEl ? curingSelectEl.value : '';
      const packSelectEl = sectionEl ? sectionEl.querySelector('[data-pack-select]') : null;
      // El selector de pack solo se muestra en los jamones loncheados (cortado a mano). Si está oculto no debe viajar al carrito:
      // antes enviaba "Pack: 1 ud." también para chorizos, packs, etc.
      const packWrap = packSelectEl ? packSelectEl.closest('[data-selector-type]') : null;
      const packVisible = !packWrap || packWrap.style.display !== 'none';
      const packVal = packSelectEl && packVisible ? packSelectEl.value : '';
      const cartBody = {
        id: variantId,
        quantity: getQty(),
        properties: {}
      };
      if (curingVal) cartBody.properties['Punto de curación'] = curingVal;
      if (packVal) cartBody.properties['Pack'] = packVal;

      const ctrl = new AbortController();
      const tOut = setTimeout(() => ctrl.abort(), 12000);

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(cartBody),
        signal: ctrl.signal
      });
      clearTimeout(tOut);

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.description || 'HTTP ' + res.status);
      }

      /* Añadir upsell items seleccionados */
      const upsellChecks = document.querySelectorAll('#cm-upsell-' + SID + ' .cm-upsell__check:checked');
      for (const chk of upsellChecks) {
        const vid = chk.dataset.variantId;
        const disc = parseInt(chk.dataset.disc || '0', 10);
        if (!vid) continue;
        const upBody = { id: vid, quantity: 1, properties: {} };
        if (disc > 0) upBody.properties['Descuento bundle'] = '-' + disc + '%';
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(upBody)
        }).catch(() => {});
      }

      setAddBtnState('done');
      updateCartCount();
      revealCombina();

      // Wait for cart to be fetched and rendered before opening drawer
      try {
        if (typeof window.fetchAndRenderCart === 'function') {
          await window.fetchAndRenderCart();
        } else {
          console.warn('[main-product] fetchAndRenderCart not available');
        }
      } catch (e) {
        console.error('[main-product] Error fetching cart:', e);
      }

      // Always open cart to show the drawer
      if (typeof window.openCart === 'function') {
        window.openCart(true);
      } else {
        console.warn('[main-product] openCart not available');
      }

      setTimeout(() => setAddBtnState('idle'), 2500);
    } catch(err) {
      console.warn('[CM] Cart add failed:', err && err.message);
      setAddBtnState('idle');
    } finally {
      isSubmitting = false;
    }
  }

  if (mainForm) {
    mainForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCartAjax();
    });
  }

  /* ── Toggle descripción ── */
  const descToggle = $('cm-desc-toggle-' + SID);
  if (descToggle) {
    const fullEl    = $('cm-desc-full-' + SID);
    const previewEl = $('cm-desc-preview-' + SID);
    const moreText  = descToggle.querySelector('.cm-desc-toggle__more');
    const lessText  = descToggle.querySelector('.cm-desc-toggle__less');

    descToggle.addEventListener('click', () => {
      const expanded = descToggle.getAttribute('aria-expanded') === 'true';
      descToggle.setAttribute('aria-expanded', String(!expanded));
      if (fullEl)    {
        fullEl.classList.toggle('is-open', !expanded);
        fullEl.setAttribute('aria-hidden', String(expanded));
      }
      if (previewEl) previewEl.style.display = expanded ? '' : 'none';
      if (moreText)  moreText.style.display  = expanded ? '' : 'none';
      if (lessText)  lessText.style.display  = expanded ? 'none' : '';
    });
  }

  /* ── Sticky ATC ── */
  const addBtnEl  = $('cm-add-' + SID);
  const stickyAtc = $('cm-sticky-atc-' + SID);
  const stickyBtn = $('cm-sticky-btn-' + SID);

  if (addBtnEl && stickyAtc) {
    /* En el editor de Shopify siempre visible para poder diseñar */
    if (window.Shopify && Shopify.designMode) {
      stickyAtc.classList.add('is-visible');
      stickyAtc.setAttribute('aria-hidden', 'false');
    } else if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const visible = !entry.isIntersecting;
          stickyAtc.classList.toggle('is-visible', visible);
          stickyAtc.setAttribute('aria-hidden', String(!visible));
        });
      }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
      observer.observe(addBtnEl);
    }
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => addToCartAjax());
  }

  /* ── Scroll reveal ── */
  if ('IntersectionObserver' in window) {
    const revealObs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.cm-reveal').forEach(el => revealObs.observe(el));
  } else {
    document.querySelectorAll('#cm-pdp-' + SID + ' .cm-reveal').forEach(el => el.classList.add('is-revealed'));
  }

  /* ── Wishlist toggle ── */
  const wishlistBtn = $('cm-wishlist-' + SID);
  if (wishlistBtn) {
    const wishlistHandle = data.productHandle;
    const wishlistText = wishlistBtn.querySelector('.cm-wishlist-text');

    function setWishlistState(active) {
      wishlistBtn.classList.toggle('is-active', active);
      wishlistBtn.setAttribute('aria-pressed', String(active));
      if (wishlistText) wishlistText.textContent = active ? cmT('wishlist_saved', 'Guardado en tu lista') : cmT('wishlist_add', 'Añadir a la lista de deseos');
    }

    /* Lee localStorage directamente (no depende de que wishlist-drawer.js ya
       se haya ejecutado — ambos scripts son `defer` y este corre antes). */
    function readWishlistInitialState() {
      try {
        var raw = localStorage.getItem('cm_wishlist');
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) && list.indexOf(wishlistHandle) !== -1;
      } catch (e) {
        return false;
      }
    }

    setWishlistState(readWishlistInitialState());

    wishlistBtn.addEventListener('click', () => {
      /* Al hacer click ya pasó DOMContentLoaded, así que wishlist-drawer.js
         (también defer) ya se ejecutó y expuso esta función globalmente. */
      if (typeof window.toggleWishlistItem === 'function') {
        setWishlistState(window.toggleWishlistItem(wishlistHandle));
      }
    });
  }

  /* ── Productos complementarios ── */
  const compEl = $('cm-comp-' + SID);
  if (compEl) {
    const compListEl = $('cm-comp-list-' + SID);
    const compProductId = compEl.dataset.productId;
    const compMax = parseInt(compEl.dataset.max || '3', 10);
    const compFallback = compEl.dataset.fallback || '';

    function compImgSrc(p) {
      var fi = p.featured_image;
      if (!fi) return '';
      return typeof fi === 'string' ? fi : (fi.src || '');
    }

    function renderCompItems(products) {
      if (!products || products.length === 0) {
        compEl.style.display = 'none';
        return;
      }
      compListEl.innerHTML = '';
      products.slice(0, compMax).forEach(function(p) {
        var variant = p.variants && p.variants[0];
        if (!variant) return;
        var available = variant.available !== false;
        var img = compImgSrc(p);
        var card = document.createElement('div');
        card.className = 'cm-comp__card';
        card.innerHTML =
          (img ? '<img class="cm-comp__card-img" src="' + img + '" alt="' + escapeHtml(p.title) + '" width="56" height="56" loading="lazy">' : '') +
          '<div class="cm-comp__card-body">' +
            '<p class="cm-comp__card-name">' + escapeHtml(p.title) + '</p>' +
            '<p class="cm-comp__card-price">' + formatMoney(variant.price) + '</p>' +
          '</div>' +
          '<button type="button" class="cm-comp__atc-btn" data-variant-id="' + variant.id + '"' + (!available ? ' disabled' : '') + '>' +
            (available ? cmT('add_to_my_cart', 'Agregar a mi cesta') : cmT('sold_out', 'Agotado')) +
          '</button>';
        card.querySelector('.cm-comp__atc-btn').addEventListener('click', async function() {
          var btn = this;
          var vid = btn.dataset.variantId;
          btn.disabled = true;
          btn.textContent = 'A\xf1adiendo…';
          try {
            var res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
            });
            if (!res.ok) throw new Error('HTTP ' + res.status);
            btn.textContent = '✓ A\xf1adido';
            updateCartCount();
            if (typeof window.fetchAndRenderCart === 'function') window.fetchAndRenderCart();
            if (typeof window.openCart === 'function') window.openCart(true);
            setTimeout(function() {
              btn.disabled = false;
              btn.textContent = 'Agregar a mi cesta';
            }, 2200);
          } catch(e) {
            btn.disabled = false;
            btn.textContent = 'Agregar a mi cesta';
          }
        });
        compListEl.appendChild(card);
      });
    }

    fetch('/recommendations/products.json?product_id=' + compProductId + '&limit=' + compMax + '&intent=complementary')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var lista = sinAlcohol(d.products);
        if (lista.length > 0) {
          renderCompItems(lista);
        } else if (compFallback) {
          return fetch('/collections/' + compFallback + '/products.json?limit=' + (compMax + 1))
            .then(function(r) { return r.json(); })
            .then(function(d2) {
              renderCompItems(sinAlcohol(d2.products).filter(function(p) { return String(p.id) !== compProductId; }));
            });
        } else {
          compEl.style.display = 'none';
        }
      })
      .catch(function() { compEl.style.display = 'none'; });
  }

})();
}); // DOMContentLoaded
